module.exports = __webpack_public_path__ + "static/media/App-Dev.b31db173.png";